// import getValuePath from "@helpers/getValuePath.helper";
// import jiff from 'jiff';
// import * as jsonpatch from 'fast-json-patch';
// import texthelper from "@helpers/text.helper";
import { mergeDeep } from "@helpers/object.helper";

const TOOLS = () => {
  return [
    "heading",
    "family",
    "size",
    "lineHeight",
    "bold",
    "italic",
    "underline",
    "color",
    "backgroundColor",
    "subscript",
    "superscript",
    "link",
    "align",
    "listBullet",
    "listOrder",
    "outdent",
    "indent",
    "icon",
    "imageIcon",
    "fontAwesome",
  ];
}
const POSITION = () => {
  return {
    top: "0",
    left: "0",
  }
}
const OPTIONS = () => {
  return {
    originalTargetID: '',
    content: '',
    toolbar: true,
    formats: {},
    minWidth: 0,
    style: {},
    callback: () => {},
  }
};
const FORMATS = () => {
  return {
    block: { tagName: 'P' },
    inline: { tagName: 'SPAN' },
    font: { whitelist: undefined },
    fontOld: { whitelist: undefined }, // will delete
    family: { whitelist: null },
    size: { whitelist: null },
    sizeAttribute: { whitelist: null },
    lineHeight: { whitelist: null },
    fontWeight: { whitelist: ['bold', 'unset'] },
    fontStyle: { whitelist: ['italic', 'unset'] },
    decoration: { whitelist: ['underline', 'unset'] },
    align: { whitelist: ["right", "left", "center", "justify"] },
    linkType: { whitelist: null },
    linkPageID: { whitelist: null },
    linkSectionID: { whitelist: null },
    linkPhoneCode: { whitelist: null },
    linkFileID: { whitelist: null },
    linkFileName: { whitelist: null },
    linkTarget: { whitelist: null },
    linkTypeOld: { whitelist: null }, // will delete
    linkPageIdOld: { whitelist: null }, // will delete
    linkSectionIdOld: { whitelist: null }, // will delete
    linkDocNameOld: { whitelist: null }, // will dlete
    phoneCodeOld: { whitelist: null }, // will delete
    isIcon: { whitelist: null },
    iconName: { whitelist: null },
    iconContent: { whitelist: null },
    iconSize: { whitelist: null },
    iconColor: { whitelist: null },
    iconIndex: { whitelist: null },
  }
}
const KEYBOARD = () => {
  return {
    enter: true
  }
}
const STYLE = () => {
  return {
    name: null,
    cssVars: {},
  }
}

const normalizeContent = (value) => {
  if (!value) return value;
  return value.replace(/(&nbsp;\s)/g, '&nbsp;&nbsp;', value);
}

// Normalize Data
const normalizeTools = (tools) => {
  let _tools =  (tools && Array.isArray(tools)) ? tools 
        : (tools && typeof tools === 'string') ? tools.split(' ')
        : (tools === false || tools === null) ? []
        : TOOLS();

      if (_tools.indexOf('icon') != -1) {
        _tools.splice(_tools.indexOf('icon'), 1);
      }
      
      return _tools;
}
const normalizeFormats = (formats) => {
  if (!formats) return formats;
  let _formats = mergeDeep(FORMATS(), formats);
  return _formats;
}

// Format
const formatTemplate = (selectionFormat) => {
  return selectionFormat.template || selectionFormat.font || selectionFormat.fontOld || formatHeaderToTemplate(selectionFormat.header);
};
const formatHeaderToTemplate = (value) => {
  if (!value) return 'paragraph1';
  return `heading${value}`;
};

// MostFontSize
const getMostFontSize = (contents) => {
  let summary = {};
  contents.ops.forEach(content => {
    let isEndLine = false;
    let text = '';
    let length = 0;
    if (typeof content.insert === 'string') {
      isEndLine = content.insert.toString().includes("\n");
      text = content.insert.replaceAll("\n", "");
      length = parseInt(text.length);
    } else if (content.insert.icon) {
      text = '';
      length = 0;
    }

    let size = 'parent';
    if (content.attributes && content.attributes.size) {
      size = content.attributes.size;
    } else if (content.attributes && content.attributes.template) {
      size = content.attributes.template;
    } else if (content.attributes && content.attributes.font) {
      size = content.attributes.font;
    } else if (content.attributes && content.attributes.fontOld) {
      size = content.attributes.fontOld;
    } else if (isEndLine) {
      size = formatHeaderToTemplate(content.attributes && content.attributes.header);
    }

    if (!summary[size]) summary[size] = { length: 0, texts: [] };

    if (isEndLine && summary['parent']) {
      summary[size].length += parseInt(summary['parent'].length);
      summary[size].texts.push(...summary['parent'].texts);
      delete summary['parent'];
    }
    
    summary[size].length += length;
    summary[size].texts.push(text);
  });

  return Object.keys(summary).reduce((a, b) => (summary[a].length < summary[b].length) ? b : a);
};

// ThemeFont to Templates
const normalizeFormatFamily = (value) => {
  if (!value) return undefined;
  if (!value.startsWith('"')) return `"${value}"`;
  return value;
}

const normalizeFormatSize = (value) => {
  if (!value) return undefined;
  value = parseInt(value);
  return `${value}px`;
}

const normalizeFormatFontWeight = (value) => {
  if (!value) return undefined;
  return 'bold';
}

const normalizeFormatFontStyle = (value) => {
  if (!value) return undefined;
  return 'italic';
}

const normalizeFormatDecoration = (value) => {
  if (!value) return undefined;
  return 'underline';
}

const normalizeFormatColor = (value) => {
  if (!value) return undefined;
  if (value.startsWith('--tpc-')) return `rgba(var(${value}), 100%)`; // --tpc-11 => rgba(var(--tpc-11), 100%)
  return value.toUpperCase(); // #xxxxxx => #XXXXXX
}

const normalizeFormatAlign = (value) => {
  if (!value) return undefined;
  if (value == 'start') return 'left'
  if (value == 'end') return 'right'
  return value
}


const state = {
  options: OPTIONS(),
  
  init: false,
  active: false,
  ready: false,
  show: false,
  forceFocus: false, // true when use other tool

  selectionFormat: {},
  selectionFormatTemplate: {},
  selectionFormatMerge: {},
  mostFontSize: undefined,

  // Templates
  templateFormatsDefault: {
    heading1: {},
    heading2: {},
    heading3: {},
    heading4: {},
    paragraph1: {},
    paragraph2: {},
    paragraph3: {},
    link: {},
    productPrice: {},
  },
  templateFormats: {},

  // Editor
  quill: undefined, // quill
  editor: undefined,

  // Original
  original: {
    show: true,
    target: undefined,
    targetID: '',
    content: '',
    contentEditing: '',
  },

  // Container
  container: {
    target: undefined,
    width: "0",
    height: "0",
    minWidth: 0,
    position: POSITION(),
    content: 'init',
  },

  // Tool
  toolbar: {
    enable: true,
    show: false,
    target: undefined,
    tools: [],
    position: POSITION(),
  },
  toolbarIcon: {
    show: false,
    target: undefined,
    position: POSITION(),
    iconTarget: undefined,
  },
  selectionIcon: {
    active: false,
    target: undefined,
    frame: {
      show: false,
      target: undefined,
      width: 0,
      height:0,
      position: POSITION(),
      labelClass: [],
    },
    toolbar: {
      show: false,
      target: undefined,
      position: POSITION(),
    },
  },
  canUpdateFontTemplate: false,

  // Keyboard
  keyboard: KEYBOARD(),

  // Format
  formats: FORMATS(),

  // Style
  styles: [],
  style: STYLE(),

  // Callback
  callback: {},
  
  demoActiveAnimation: null,
}
const getters = {
  texteditor: state => {
    return state
  },
}
const actions = {
  // Init
  async initTextEditor({ commit }, { 
    quill, 
    editor, 
    containerTarget,
    toolbarTarget,
    iconFrameTarget,
    iconToolbarTarget,
    templateFormats,
  }) {
    await commit('SET', { 
      quill: quill,
      editor: editor,
      templateFormatsDefault: templateFormats,
    })
    commit('SET_CONTAINER', { target: containerTarget });
    commit('SET_TOOLBAR', { target: toolbarTarget });
    commit('SET_SELECTION_ICON_FRAME', { target: iconFrameTarget });
    commit('SET_SELECTION_ICON_TOOLBAR', { target: iconToolbarTarget });
    commit('SET', { init: true });
  },

  // Setup
  async setTextEditor({ rootState, commit, dispatch }, {
    originalTargetID = '',
    content = '',
    toolbar = true,
    keyboard = {},
    formats = {},
    minWidth = 0,
    style = {},
    styles = [],
    callback = {},
    templateFormats = null,
    canUpdateFontTemplate = true
  }) {
    if (!rootState.preview) {
      const options = { 
        originalTargetID,
        content: normalizeContent(content),
        toolbar,
        keyboard,
        formats,
        minWidth,
        style,
        styles,
        callback,
        templateFormats,
        canUpdateFontTemplate,
      };

      dispatch('active');
      dispatch('unready');
      
      // Setup Some

      commit('SET', { forceFocus: false });
      commit('SET', { selectionFormat: {} });
      commit('SET', { selectionFormatTemplate: {} });
      commit('SET', { selectionFormatMerge: {} });
      commit('SET', { mostFontSize: undefined });

      // Setup
      await dispatch('setupOptions', { options });
      await dispatch('setupTemplateFormats', { options });
      await dispatch('setupCallback', { options });
      dispatch('setupOriginal', { options });
      dispatch('setupContainer', { options });
      dispatch('setupToolbar', { options });
      dispatch('setupSelectionIcon', { options });
      dispatch('setupKeyboard', { options });
      await dispatch('setupFormats', { options });
      dispatch('setupStyle', { options });
      await dispatch('reContainer'); // for valid position when focus
      await dispatch('setupContent', { options }); // wait formats + quill register + reContainer || effect focus + contentEditing + reContainer

      dispatch('ready'); // wait update contentEditing || reFrame
      dispatch('show');

      setTimeout(() => {
        state.editor.setSelection(0, state.editor.getLength());
        state.editor.history.clear();
      }, 1); // if not wait, will blur | don't know why
    }
  },
  setupOptions({ commit }, { options }) {
    commit('SET_OPTIONS', options);
  },
  setupCallback({ commit }, { options }) {
    commit('SET_CALLBACK', options.callback);
  },
  setupOriginal({ commit }, { options }) {
    commit('SET_ORIGINAL', { 
      targetID: options.originalTargetID,
      target: document.getElementById(options.originalTargetID),
      content: options.content,
      contentEditing: options.content,
    });
  },
  setupContainer({ commit }, { options }) {
    commit('SET_CONTAINER', {
      minWidth: options.minWidth,
    });
  },
  setupToolbar({ commit }, { options }) {
    let tools = normalizeTools(options.toolbar);
    commit('SET_TOOLBAR', {
      enable: Boolean(tools.length > 0),
      tools: tools 
    });
    commit('SET_CAN_UPDATE_FONT_TEMPLATE', options.canUpdateFontTemplate);
  },
  setupSelectionIcon({ commit }) {
    commit('SET_SELECTION_ICON', {
      active: false,
      target: undefined,
    });
    commit('SET_SELECTION_ICON_FRAME', {
      show: false,
      // target: undefined,
      width: 0,
      height:0,
      position: POSITION(),
      labelClass: [],
    });
    commit('SET_SELECTION_ICON_TOOLBAR', {
      show: false,
      // target: undefined,
      position: POSITION(),
    });
  },
  setupKeyboard({ commit }, { options }) {
    commit('SET', { 
      keyboard: options.keyboard, 
    });
  },
  setupFormats({ commit }, { options }) {
    let formats = normalizeFormats(options.formats);
    commit('SET_FORMATS', formats);
  },
  setupStyle({ commit }, { options }) {
    commit('SET', {
      styles: options.styles,
      style: {
        name: options.style.name,
        cssVars: options.style.cssVars,
      }
    });
  },
  setupContent({ commit }, { options }) {
    let content = options.content;
    if (content.includes('icon class="icon"')) content = content.replaceAll('icon class="icon"', 'icon class="iconOld"');
    commit('SET_CONTAINER', {
      content: content,
    });
  },

  // Clear
  async clearTextEditor({ rootState, state, commit, dispatch }) {
    if (!rootState.preview) {

      dispatch('inactive');
      await dispatch('hide');
      dispatch('unready');
      
      // Clear Some
      commit('SET', { forceFocus: false });
      commit('SET', { selectionFormat: {} });
      commit('SET', { selectionFormatTemplate: {} });
      commit('SET', { selectionFormatMerge: {} });
      commit('SET', { mostFontSize: undefined });

      // Clear
      dispatch('clearOptions');
      dispatch('clearOriginal');
      dispatch('clearContainer');
      dispatch('clearToolbar');
      dispatch('clearSelectionIcon');
      dispatch('clearKeyboard');
      // dispatch('clearFormats'); // reduce quill register
      dispatch('clearStyle');
      dispatch('clearCallback'); // all done

      state.editor.history.clear();
    }
  },
  clearOptions({ commit }) {
    commit('SET_OPTIONS', OPTIONS());
  },
  clearCallback({ commit }) {
    commit('SET_CALLBACK', {});
  },
  clearOriginal({ commit }) {
    commit('SET_ORIGINAL', { 
      show: true,
      targetID: '',
      target: undefined,
      content: '',
      contentEditing: '',
    });
  },
  clearContainer({ commit }) {
    commit('SET_CONTAINER', {
      width: "0",
      height: "0",
      minWidth: 0,
      position: POSITION(),
      content: 'clear',
    });
  },
  clearToolbar({ commit }) {
    commit('SET_TOOLBAR', {
      // target: null,
      enable: true,
      show: false,
      tools: [],
      position: POSITION(),
    });
  },
  clearSelectionIcon({ commit }) {
    commit('SET_SELECTION_ICON', {
      active: false,
      target: undefined,
    });
    commit('SET_SELECTION_ICON_FRAME', {
      show: false,
      // target: undefined,
      width: 0,
      height:0,
      position: POSITION(),
      labelClass: [],
    });
    commit('SET_SELECTION_ICON_TOOLBAR', {
      show: false,
      // target: undefined,
      position: POSITION(),
    });
  },
  clearKeyboard({ commit }) {
    commit('SET', { 
      keyboard: KEYBOARD(),
    });
  },
  clearFormats({ commit }) {
    commit('SET_FORMATS', FORMATS());
  },
  clearStyle({ commit }) {
    commit('SET', {
      styles: [],
      style: STYLE()
    });
  },

  // Status
  active({ commit }) {
    commit('SET', { active: true });
  },
  inactive({ commit }) {
    commit('SET', { active: false });
  },
  ready({ commit, dispatch }) {
    commit('SET', { ready: true });
    dispatch('onReady');
  },
  unready({ commit }) {
    commit('SET', { ready: false });
  },
  show({ commit, dispatch }) {
    commit('SET', { show: true });
    commit('SET_ORIGINAL', { show: false });
    dispatch('showToolbar');
  },
  hide({ commit, dispatch }) {
    commit('SET', { show: false });
    commit('SET_ORIGINAL', { show: true });
    dispatch('hideToolbar');
  },

  // Events
  async onReady({ state }) {
    const html = state.editor.root.innerHTML;
    const text = state.editor.getText();
    const contents = state.editor.getContents();
    const selection = state.editor.getSelection();

    // Callback
    if (state.callback.onReady) {
      state.callback.onReady({
        editor: state.editor,
        text: text,
        html: html,
        contents: contents,
        selection: selection,
      });
    }
  },
  async onFocus({ state, dispatch }) {
    const contents = state.editor.getContents();
    const selection = state.editor.getSelection();
    const selectionFormat = state.editor.getFormat(selection);
    const selectionFormatTemplate = state.templateFormats[formatTemplate(selectionFormat)] || {};
    const selectionFormatMerge = { ...selectionFormatTemplate, ...selectionFormat };
    const mostFontSize = getMostFontSize(contents);
    const text = state.editor.getText();

    // SelectionFormat
    dispatch("setSelectionFormat", { 
      selectionFormat: selectionFormat,
      selectionFormatTemplate: selectionFormatTemplate,
      selectionFormatMerge: selectionFormatMerge,
    });

    // MostFontSize
    dispatch("setMostFontSize", { 
      mostFontSize: mostFontSize 
    });

    // Callback
    if (state.callback.onFocus) {
      state.callback.onFocus({
        editor: state.editor,
        selection: selection,
        format: selectionFormat,
        mostFontSize: mostFontSize,
        text: text,
      });
    }
  },
  async onChange({ state, dispatch }, { event }) {
    const html = event.html;
    const text = event.text;
    const contents = state.editor.getContents();
    const selection = state.editor.getSelection();
    const selectionFormat = state.editor.getFormat(selection);
    const selectionFormatTemplate = state.templateFormats[formatTemplate(selectionFormat)] || {};
    const selectionFormatMerge = { ...selectionFormatTemplate, ...selectionFormat };
    const mostFontSize = getMostFontSize(contents);

    // Content
    await dispatch("setContent", { content: html });

    // SelectionFormat
    dispatch("setSelectionFormat", { 
      selectionFormat: selectionFormat,
      selectionFormatTemplate: selectionFormatTemplate,
      selectionFormatMerge: selectionFormatMerge,
    });

    // MostFontSize
    dispatch("setMostFontSize", { 
      mostFontSize: mostFontSize 
    });

    // Callback
    if (state.callback.onChange) {
      state.callback.onChange({
        editor: state.editor,
        text: text,
        html: html,
        contents: contents,
        selection: selection,
        format: selectionFormat,
        mostFontSize: mostFontSize,
      });
    }

    // dispatch('reContainer');
    // dispatch("reToolbar");
  },
  async onBlur({ state, dispatch }) {
    const index = 0;
    const length = state.editor.getLength();
    const html = state.editor.root.innerHTML;
    const text = state.editor.getText(index, length);
    const contents = state.editor.getContents();
    const selectionFormat = state.editor.getFormat(index, length);
    const mostFontSize = getMostFontSize(contents);
    
    // Callback
    if (state.callback.onBlur) {
      state.callback.onBlur({
        editor: state.editor,
        text: text,
        html: html,
        contents: contents,
        format: selectionFormat,
        mostFontSize: mostFontSize,
      });
    }

    dispatch('clearTextEditor');
  },
  onFocusIcon({ state }) {
    if (state.callback.onFocusIcon) state.callback.onFocusIcon();
  },
  onBlurIcon({ state }) {
    if (state.callback.onBlurIcon) state.callback.onBlurIcon();
  },

  // API
  setData({ commit }, data) {
    commit('SET', data);
  },
  setToolbar({ commit }, toolbar) {
    commit('SET_TOOLBAR', toolbar);
  },
  setSelectionIcon({ commit }, settings) {
    commit('SET_SELECTION_ICON', settings);
  },
  setSelectionIconFrame({ commit }, settings) {
    commit('SET_SELECTION_ICON_FRAME', settings);
  },
  setSelectionIconToolbar({ commit }, settings) {
    commit('SET_SELECTION_ICON_TOOLBAR', settings);
  },
  async setContent({ commit, dispatch }, { content }) {
    await commit('SET_ORIGINAL', { contentEditing: content });
    dispatch('reContainer');
  },
  setSelectionFormat({ commit }, { selectionFormat, selectionFormatTemplate, selectionFormatMerge }) {
    commit('SET', { 
      selectionFormat: selectionFormat,
      selectionFormatTemplate: selectionFormatTemplate,
      selectionFormatMerge: selectionFormatMerge,
    });
  },
  setMostFontSize({ commit }, { mostFontSize }) {
    commit('SET', { mostFontSize: mostFontSize });
  },
  setupTemplateFormats({ commit }, { options = null}) {
    let _options = options ? options : state.options
    let _templateFormats = {}
    if (_options.templateFormats) {
      _options.templateFormats.forEach(item => {
        if (typeof item === 'string' && state.templateFormatsDefault[item]) {
          _templateFormats[item] = state.templateFormatsDefault[item]
        } else if (typeof item === 'object') {
          _templateFormats[item.key] = {
            family: normalizeFormatFamily(item.formats.family),
            size: normalizeFormatSize(item.formats.size),
            fontWeight: normalizeFormatFontWeight(item.formats.isBold),
            fontStyle: normalizeFormatFontStyle(item.formats.isItalic),
            decoration: normalizeFormatDecoration(item.formats.isUnderline),
            color: normalizeFormatColor(item.formats.color),
            lineHeight: 1.2,
            align: normalizeFormatAlign(item.formats.align),
          }
        }
      });
    } else {
      _templateFormats = state.templateFormatsDefault
    }

    commit('SET', { templateFormats: _templateFormats})
  },

  // Container
  reContainer({ state, commit }) {
    let rectOriginal = state.original.target.getBoundingClientRect();
    commit('SET_CONTAINER', { 
      width: `${rectOriginal.width}px`, 
      height: `${rectOriginal.height}px`,
      position: {
        // top: `${rectOriginal.top + document.documentElement.scrollTop + rectOriginal.height}px`,
        top: `${rectOriginal.top + document.documentElement.scrollTop}px`,
        left: `${rectOriginal.left}px`,
      },
    })
  },

  // Toolbar
  showToolbar({ commit }) {
    commit('SET_TOOLBAR', { show: true })
  },
  hideToolbar({ commit }) {
    commit('SET_TOOLBAR', { show: false })
  },
  reToolbar({ state, commit }) {
    const rectOriginal = state.original.target.getBoundingClientRect(); // should use container but it return 0
    commit('SET_TOOLBAR', { 
      position: { 
        top: `${rectOriginal.height + 50}px`,
        left: 0,
      }
    });
  },

  // Icon Frame
  showIconFrame({ commit, dispatch }) {
    dispatch('reIconFrame');
    commit('SET_SELECTION_ICON_FRAME', { show: true })
  },
  hideIconFrame({ commit }) {
    commit('SET_SELECTION_ICON_FRAME', { show: false })
  },
  reIconFrame({ state, commit }) {
    const $contianer = state.editor.root;
    const $icon = state.selectionIcon.target;
    const $svg = $icon.querySelector('svg');
    commit('SET_SELECTION_ICON_FRAME', {
      width: $svg.getBoundingClientRect().width + 4 + 4,
      height: $svg.getBoundingClientRect().height + 4 + 4,
      labelClass: ['top', 'left'],
      position: { 
        top: `${$svg.getBoundingClientRect().top - $contianer.getBoundingClientRect().top - 4}px`,
        left: `${$svg.getBoundingClientRect().left - $contianer.getBoundingClientRect().left - 4}px`,
      }
    })
  },
  // Icon Toolbar
  // async showIconToolbar({ commit, dispatch }) {
  //   await commit('SET_SELECTION_ICON_TOOLBAR', { show: true })
  //   dispatch('reIconToolbar');
  // },
  // hideIconToolbar({ commit }) {
  //   commit('SET_SELECTION_ICON_TOOLBAR', { show: false })
  // },
  // reIconToolbar({ state, commit }) {
  //   const $frame = state.selectionIcon.frame.target;
  //   const $frameLabel = $frame.querySelector('.mwe-texteditor-iconFrame-label');
  //   const $toolbar = state.selectionIcon.toolbar.target;
  //   commit('SET_SELECTION_ICON_TOOLBAR', {
  //     position: { 
  //       top: `${$frame.offsetTop - $frameLabel.getBoundingClientRect().height - 10 - $toolbar.getBoundingClientRect().height}px`,
  //       left: `${$frame.offsetLeft - ($toolbar.getBoundingClientRect().width / 2) + ($frame.getBoundingClientRect().width / 2)}px`,
  //     }
  //   })
  // },
  // Icon Toolbar
  async showIconToolbar({ commit, dispatch }) {
    await commit('SET_SELECTION_ICON_TOOLBAR', { show: true })
    dispatch('reIconToolbar');
  },
  hideIconToolbar({ commit }) {
    commit('SET_SELECTION_ICON_TOOLBAR', { show: false })
  },
  reIconToolbar({ state, commit }) {
    const $contianer = state.editor.root;
    const $toolbar = state.selectionIcon.toolbar.target;
    const $icon = state.selectionIcon.target;
    const $svg = $icon.querySelector('svg');
    commit('SET_SELECTION_ICON_TOOLBAR', {
      position: { 
        top: `${$svg.getBoundingClientRect().top - $contianer.getBoundingClientRect().top - 18 - 10 - $toolbar.getBoundingClientRect().height}px`,
        left: `${$svg.getBoundingClientRect().left - $contianer.getBoundingClientRect().left - ($toolbar.getBoundingClientRect().width / 2) + ($svg.getBoundingClientRect().width / 2)}px`,
      }
    })
  },
  showTextAnimation({ commit }, type) {
    commit('SET_IS_ACTIVE_ANIMATION', type)
  },
  hideTextAnimation({ commit }) {
    commit('SET_IS_ACTIVE_ANIMATION', null)
  },
}
const mutations = {
  SET(state, settings) {
    Object.keys(settings).forEach(key => state[key] = settings[key]);
  },

  SET_OPTIONS(state, settings) {
    Object.keys(settings).forEach(key => state.options[key] = settings[key]);
  },
  SET_ORIGINAL(state, settings) {
    Object.keys(settings).forEach(key => state.original[key] = settings[key]);
  },
  SET_CONTAINER(state, settings) {
    Object.keys(settings).forEach(key => state.container[key] = settings[key]);
  },
  SET_TOOLBAR(state, settings) {
    Object.keys(settings).forEach(key => state.toolbar[key] = settings[key]);
  },
  SET_SELECTION_ICON(state, settings) {
    Object.keys(settings).forEach(key => state.selectionIcon[key] = settings[key]);
  },
  SET_SELECTION_ICON_FRAME(state, settings) {
    Object.keys(settings).forEach(key => state.selectionIcon.frame[key] = settings[key]);
  },
  SET_SELECTION_ICON_TOOLBAR(state, settings) {
    Object.keys(settings).forEach(key => state.selectionIcon.toolbar[key] = settings[key]);
  },
  SET_FORMATS(state, settings) {
    Object.keys(settings).forEach(key => state.formats[key] = settings[key]);
  },
  SET_STYLE(state, settings) {
    Object.keys(settings).forEach(key => state.style[key] = settings[key]);
  },
  SET_CALLBACK(state, value) {
    state.callback = value;
  },
  SET_IS_ACTIVE_ANIMATION(state, value) {
    state.demoActiveAnimation = value
  },
  SET_CAN_UPDATE_FONT_TEMPLATE(state, value) {
    state.canUpdateFontTemplate = value;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};